













import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import Alert from '@/components/Global/Alert.vue';

@Component({
	components: {
		Alert,
	},
})
export default class NotificationIcon extends Vue {
	@Getter('getUnreadNotifications', { namespace: 'Notifications' })
	private getUnreadNotifications: any;
	private notificationAccess: string = process.env.VUE_APP_NOTIFICATIONS;
}
